import React from 'react'
import { Link } from "react-router-dom"

export const Anclas = ({title,estilos,enlace,textoAncla,eventoAncla}) => {
  return (
    <Link title={title} to={enlace} className={estilos} onClick={eventoAncla}>{textoAncla}</Link>
  )
}
